import axios from 'axios';
import { getFilenameFromContentDisposition } from '../../../study-designer/package/export/support/getFilenameFromContentDisposition';

/**
 * Downloads the given version of a published report as an HTML file.
 * The HTML is generated server side. This only triggers the browser save dialog.
 */
export async function downloadPublishedAgenticArtifact(
    spaceId: string,
    artifactId: string,
    version: number
): Promise<void> {
    const response = await axios.get<Blob>(
        `/api/study-designer/study-spaces/${spaceId}/published-agentic-artifacts/${artifactId}/versions/${version}/download`,
        {
            responseType: 'blob',
            params: { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone },
        }
    );

    const fileName = getFilenameFromContentDisposition(
        response.headers['content-disposition'] ?? null,
        'html',
        'report'
    );
    const blobUrl = URL.createObjectURL(response.data);

    // The link is clicked without being added to the page. A click on an element that is on the page reaches
    // document-level listeners, and FaroOverlay treats it as a click outside, which closes the report modal.
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = fileName;
    anchor.click();

    // Delay revoking URL so the download finishes
    setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
}
